<!--  Toggle switch visible only to the Admin  -->
<div
	*ngIf="isLoggedInUserAdmin && !hideToggleSwitch"
	fxLayout="row"
	fxLayoutAlign="start center"
	fxLayoutGap="1%"
>
	<mat-slide-toggle
		[(ngModel)]="showDonorList"
		(change)="onToggleChange($event)"
		id="hide_donor_list_toggle"
		color="primary"
	>
		<span i18n="@@donor_list_show_donation_received"
			>Show Donation Recieved</span
		>
	</mat-slide-toggle>
	<img
	    class="p-l-m"
		matTooltip="{{ this.tooltip }}"
		src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/info14px/w=12"
	/>
</div>
<br />

<div fxLayout="row" fxFill fxLayoutAlign="center center" fxLayoutGap="5%">
	<div fxLayout="column" fxFlex="100%" fxLayoutAlign="center start">
		<h2>
			<span i18n="@@donor_list_short_donation_heading">Donations</span>&nbsp;
			<ng-template
				id="donation_count"
				[ngIf]="!isDonorListLoading"
				[ngIfElse]="spinner"
			>
				({{ this.count }})
			</ng-template>
		</h2>
	</div>
	<div fxLayout="column" fxFlex="100%" fxLayoutAlign="center end">
		<a
			id="short_donor_list_view_all"
			i18n="@@donorListShort_viewAll_button"
			mat-button
			color="accent"
			(click)="viewFullDonorList()"
		>
			View All
		</a>
	</div>
</div>

<mat-tab-group *ngIf="showDonorList">
	<mat-tab label="{{ label_donorList_tab1 }}">
		<div
			fxLayout="row"
			fxFlex="100%"
			fxLayoutAlign="center center"
			class="p-t-s"
		>
			<div
				fxLayout="column"
				fxFlex="100%"
				fxLayoutAlign="center center"
				fxLayoutGap="5%"
			>
				<!--SINGLE DONOR ROW-->
				<div
					fxLayout="column"
					class="p-b-l donor-list-small"
					[style.border-bottom]="'1px solid #ddd'"
					[style.last-child]="'0px'"
					fxFill
					fxLayoutGap="5%"
					*ngFor="let donor of this.donorData; let i = index"
				>
					<div fxLayout="row" fxLayoutAlign="center center">
						<!--Avatar-->
						<div fxLayout="column" fxLayoutAlign="center center">
							<app-user-icon
								[initialLetters]="getInitial(donor?.name)"
								[index]="i"
							></app-user-icon>
						</div>
						<!--Name and Message-->
						<div
							fxLayout="column"
							fxFlex="55%"
							fxLayoutAlign="center start"
							ngClass="p-l-s"
						>
							<div id="donationName">
								<strong> {{ donor?.name }} </strong>
							</div>
							<div>
								{{ donor?.message }}
							</div>
							<!--REPLY BUTTON-->
							<div>
								<a
									*ngIf="
										(isLoggedInUserAdmin &&
											donor?.reply_message?.length <= 1) ||
										(isLoggedInUserAdmin && !donor?.reply_message)
									"
									i18n="@@button_reply"
									mat-button
									color="accent"
									class="zero-padding-margin"
									(click)="openDialog(i)"
								>
									Reply
								</a>
							</div>
						</div>
						<!--Amount-->
						<div
							fxLayout="column"
							fxFlex="30%"
							fxLayoutAlign="flex-end flex-end"
						>
							<span class="mat-option">
								{{
									donor?.amount | currency : donor?.symbol : 'symbol' : '1.0-0'
								}}
							</span>
						</div>
					</div>

					<div fxFlex="100%" fxLayout="row">
						<div fxFlex="14%"></div>
						<div fxLayout="row" fxFlex="100%">
							<div
								fxLayout="row"
								fxLayoutAlign="start center"
								fxFlex="50%"
								fxFlex.xs="80%"
							>
								<div
									*ngIf="
										donor?.reply_message && donor?.reply_message?.length > 1
									"
								>
									<img
										*ngIf="donor?.reply_message"
										width="30"
										height="30"
										loading="lazy"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/donor_small/public"
									/>
								</div>
								<div
									*ngIf="
										donor?.reply_message && donor?.reply_message?.length > 1
									"
									fxLayoutAlign="start start"
									class="m-l-xs"
									fxFill
								>
									{{ donor?.reply_message }}
									<img
										*ngIf="isLoggedInUserAdmin"
										fxLayoutAlign="center center"
										height="16px"
										class="m-l-xs"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/editSmall/public"
										(click)="openDialog(i)"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</mat-tab>
	<mat-tab label="{{ label_donorList_tab2 }}">
		<div
			fxLayout="row"
			fxFlex="100%"
			fxLayoutAlign="center center"
			class="p-t-s"
		>
			<div
				fxLayout="column"
				fxFlex="100%"
				fxLayoutAlign="center center"
				fxLayoutGap="5%"
			>
				<!--SINGLE DONOR ROW-->
				<div
					fxLayout="column"
					class="p-b-l donor-list-small"
					[style.border-bottom]="'1px solid #ddd'"
					[style.last-child]="'0px'"
					fxFill
					fxLayoutGap="5%"
					*ngFor="let donor of this.topContributors; let i = index"
				>
					<div fxLayout="row" fxLayoutAlign="center center">
						<!--Avatar-->
						<div fxLayout="column" fxLayoutAlign="center center">
							<app-user-icon
								[initialLetters]="getInitial(donor?.name)"
							></app-user-icon>
						</div>
						<!--Name and Message-->
						<div
							fxLayout="column"
							fxFlex="55%"
							fxLayoutAlign="center start"
							ngClass="p-l-s"
						>
							<div id="donationName">
								<strong> {{ donor?.name }} </strong>
							</div>
							<div>
								{{ donor?.message }}
							</div>
							<!--REPLY BUTTON-->
							<div>
								<a
									*ngIf="
										(isLoggedInUserAdmin &&
											donor?.reply_message?.length <= 1) ||
										(isLoggedInUserAdmin && !donor?.reply_message)
									"
									i18n="@@button_reply"
									mat-button
									color="accent"
									class="zero-padding-margin"
									(click)="openDialog(i)"
								>
									Reply
								</a>
							</div>
						</div>
						<!--Amount-->
						<div
							fxLayout="column"
							fxFlex="30%"
							fxLayoutAlign="flex-end flex-end"
						>
							<span class="mat-option">
								{{
									donor?.amount | currency : donor?.symbol : 'symbol' : '1.0-0'
								}}
							</span>
						</div>
					</div>

					<div fxFlex="100%" fxLayout="row">
						<div fxFlex="14%"></div>
						<div fxLayout="row" fxFlex="100%">
							<div
								fxLayout="row"
								fxLayoutAlign="start center"
								fxFlex="50%"
								fxFlex.xs="80%"
							>
								<div
									*ngIf="
										donor?.reply_message && donor?.reply_message?.length > 1
									"
								>
									<img
										*ngIf="donor?.reply_message"
										width="30"
										height="30"
										loading="lazy"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/donor_small/public"
									/>
								</div>
								<div
									*ngIf="
										donor?.reply_message && donor?.reply_message?.length > 1
									"
									fxLayoutAlign="start start"
									class="m-l-xs"
									fxFill
								>
									{{ donor?.reply_message }}
									<img
										*ngIf="isLoggedInUserAdmin"
										fxLayoutAlign="center center"
										height="16px"
										class="m-l-xs"
										src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/editSmall/public"
										(click)="openDialog(i)"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</mat-tab>
</mat-tab-group>

<!--OFFLINE-->
<div
	fxLayout="column"
	fxFill
	ngClass="pale-grey-bg p-m"
	*ngIf="isLoggedIn; else loggedOutTemplate"
>
	<div fxLayout="row" fxLayoutGap="4%" fxLayoutAlign="start center">
		<div>
			<h2 i18n="@@offline_collection_heading">Offline Collection</h2>
		</div>
		<div ngClass="p-b-xs">
			<img
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/info14px/w=12"
				matTooltip="{{ this.offlineDonationTooltip }}"
			/>
		</div>
	</div>
	<div fxLayout="column" fxLayoutGap="2%">
		<div
			[matTooltip]="addOfflineDonationTooltip"
			[matTooltipDisabled]="!isDraftOrClosed"
		>
			<button
				*ngIf="isLoggedInUserAdmin && !isWholePreview"
				mat-stroked-button
				id="addOfflineDonation"
				color="accent"
				class="hover-btn w-100"
				[disabled]="isDraftOrClosed"
				(click)="addOfflineDonation()"
				i18n="@@button_add_offline_donation"
			>
				Add Offline Donation
			</button>
		</div>
		<div [matTooltip]="viewSummaryTooltip" [matTooltipDisabled]="isViewSummary">
			<button
				mat-stroked-button
				id="viewOfflineDonationSummary"
				color="accent"
				class="hover-btn w-100"
				[disabled]="!isViewSummary"
				i18n="@@button_view_summary"
				(click)="viewOfflineDonationSummary()"
			>
				View Summary
			</button>
		</div>
	</div>
</div>
<ng-template #loggedOutTemplate>
	<div
		fxLayout="column"
		fxFill
		ngClass="pale-grey-bg p-m m-t-m"
		*ngIf="isViewSummary"
	>
		<div fxLayout="row" fxLayoutGap="4%" fxLayoutAlign="start center">
			<div>
				<h2 i18n="@@offline_collection_heading">Offline Collection</h2>
			</div>
			<div ngClass="p-b-xs">
				<img
					src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/info14px/w=12"
					matTooltip="{{ this.offlineDonationTooltip }}"
				/>
			</div>
		</div>
		<div fxLayout="column" fxLayoutGap="2%">
			<p *ngIf="!isLoggedIn">
				{{ currency_symbol }}&nbsp;{{ totalOfflineDonationAmount }}
				<span
					class="mat-typography"
					i18n="@@offline_donation_collected_by_cause"
					>was collected offline by the cause</span
				>
			</p>
			<div
				[matTooltip]="viewSummaryTooltip"
				[matTooltipDisabled]="isViewSummary"
			>
				<button
					mat-stroked-button
					color="accent"
					class="hover-btn w-100"
					[disabled]="!isViewSummary"
					i18n="@@button_view_summary"
					(click)="viewOfflineDonationSummary()"
				>
					View Summary
				</button>
			</div>
		</div>
	</div>
</ng-template>

<!-- Spinner-->
<ng-template #spinner>
	<mat-icon>
		<mat-spinner color="primary" diameter="16"> </mat-spinner>
	</mat-icon>
</ng-template>
